import * as bi from 'react-bootstrap-icons';
import { IClientTripFull } from '@bustickus/models-client';
import { Flex } from 'components';
import { Icon } from 'shared/components';

interface IProps {
  trip: IClientTripFull;
}

function TripInfo(props: IProps) {
  const price = Math.floor(props.trip.price);
  const priceString = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(price);

  return (
    <Flex direction='column'>
      {props.trip.number && (
        <Flex gap={5}>
          <Icon color='red'>
            <bi.BusFront />
          </Icon>
          <span>Номер рейса:</span>
          <b>{props.trip.number}</b>
        </Flex>
      )}
      <Flex gap={5}>
        <Icon color='red'>
          <bi.Ticket />
        </Icon>
        <span>Доступно билетов:</span>
        <b>{props.trip.freeTickets}</b>
      </Flex>
      <Flex gap={5}>
        <Icon color='red'>
          <bi.Coin />
        </Icon>
        <span>Цена билета:</span>
        <b>{priceString}</b>
      </Flex>
      {props.trip.documents.needPassport && (
        <Flex gap={5}>
          <Icon color='red'>
            <bi.Passport />
          </Icon>
          <b>Требуется паспорт</b>
        </Flex>
      )}
      {props.trip.documents.needForeignPassport && (
        <Flex gap={5}>
          <Icon color='red'>
            <bi.Passport />
          </Icon>
          <b>Требуется заграничный паспорт</b>
        </Flex>
      )}
      {props.trip.documents.visas.map((x) => (
        <Flex
          key={x.id}
          gap={5}
        >
          <Icon color='red'>
            <bi.Passport />
          </Icon>
          <b>Требуется {x.name}</b>
        </Flex>
      ))}
    </Flex>
  );
}

export default TripInfo;
